import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Chip } from '@mui/material';

const OrderBookSummary = ({ orderInfo, approvalList, approvalV2Doc }) => {
  const [finalApproveDate, setFinalApproveDate] = useState('');

  useEffect(() => {
    if (approvalV2Doc?.finalizedAt) {
      setFinalApproveDate(approvalV2Doc.finalizedAt);
      return;
    }

    if (approvalList && approvalList.length > 0) {
      const length = approvalList.length;
      const docuDt = approvalList[length - 1]['docuDt'];

      setFinalApproveDate(docuDt);
      return;
    }
    setFinalApproveDate('');
  }, [approvalList, approvalV2Doc]);

  const statusChip = {
    S: { label: '결재진행중', color: 'warning' },
    Y: { label: '결재완료',  color: 'success' },
    N: { label: '미결재',    color: 'default' },
  }[orderInfo?.ordYn] ?? { label: '-', color: 'default' };

  const headerSx = {
    backgroundColor: '#f5f5f5',
    py: 1,
    borderBottom: '2px solid #e0e0e0',
  };

  return (
    <Box sx={{ px: 2, py: 1 }}>
      {/* 헤더 행 */}
      <Grid container alignItems="center" sx={headerSx}>
        <Grid item xs={3} align="center">
          <Typography variant="caption" fontWeight={700} color="text.secondary">문서번호</Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="caption" fontWeight={700} color="text.secondary">문서명</Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="caption" fontWeight={700} color="text.secondary">작성일자</Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="caption" fontWeight={700} color="text.secondary">작성자</Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="caption" fontWeight={700} color="text.secondary">결재상태</Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="caption" fontWeight={700} color="text.secondary">최종승인일자</Typography>
        </Grid>
      </Grid>

      {/* 데이터 행 */}
      <Grid container alignItems="center" sx={{ py: 1.5 }}>
        <Grid item xs={3} align="center">
          <Typography variant="body2">{orderInfo?.roNo}</Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2">수주품의서</Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2">{orderInfo?.crtDt}</Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Typography variant="body2">{orderInfo?.crtNm}</Typography>
        </Grid>
        <Grid item xs={1} align="center">
          <Chip
            label={statusChip.label}
            color={statusChip.color}
            size="small"
            sx={{ fontWeight: 600, fontSize: '0.72rem' }}
          />
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2">{finalApproveDate || '-'}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderBookSummary;
